<!-- @veltra/icons generated sha256:46f0754efd3ccfa6 gen:8 source:src/svg/normal/sort.svg -->
<script setup lang="ts">
defineOptions({ name: 'Sort' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M1.746 6h11.262l-3.49-3.403a.484.484 0 0 1-.015-.693l.02-.021a.483.483 0 0 1 .693-.002l4.317 4.21a.53.53 0 0 1-.37.91L1.748 7a.5.5 0 0 1-.498-.504v-.01c0-.277.22-.486.496-.486m12.51 4H3.02l3.446 3.256a.49.49 0 0 1 .01.719.494.494 0 0 1-.701.004l-4.3-4.064A.53.53 0 0 1 1.839 9h12.413c.276 0 .498.228.498.504v.011a.483.483 0 0 1-.494.485"
    />
  </svg>
</template>
